import React, {Component} from 'react'
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip'
import {abbr} from './constants'
import {withStyles, createStyleSheet} from 'material-ui/styles';


const styleSheet = createStyleSheet('Article', theme => ({
    text: {
        textAlign: 'justify',
        margin: theme.spacing.unit * 2,
    },
    title: {
        marginLeft: theme.spacing.unit * 2,
        marginRight: theme.spacing.unit * 2,
    }
}));


export class ToolTip extends Component {

    render() {
        const key = this.props.keyAbbr;
        const tip = abbr[key];

        return (
            <span>
                <a data-tip data-for={key}>{key}</a>
                <ReactTooltip id={key}>
                    {tip}
                </ReactTooltip>

            </span>
        )
    }
}

ToolTip.propTypes = {
    keyAbbr: PropTypes.string.isRequired,
};

export default withStyles(styleSheet)(ToolTip);



// WEBPACK FOOTER //
// ./src/tooltip.jsx